module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var u = require('util/Util.js').default;
var zeroDisabled = (gridData[selectedRowId].attributes.addZero == 'checked' ? '' : 'disabled="disabled"');
var disabledAll = (gridData[selectedRowId].attributes.addZero == 'checked' ? 'disabled="true"' : '');

    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Number</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\" style=\"padding-right: 0px;\">\r\n        <input type=\"text\"   name=\"text\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.text ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 form-group-flex\">\r\n        <input type=\"checkbox\" name=\"allowNegative\" id=\"allowNegative\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.allowNegative))
    ; __append(" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.disabledAll))
    ; __append(" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Allow Negative</label>\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        <img id=\"align-left\" name=\"align-left\" src=\"")
    ; __append( require('editor/icons/align_left.png') )
    ; __append("\" style=\"background-color: ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.alignLeftSelection ))
    ; __append("\" />\r\n        <img id=\"align-center\" name=\"align-center\" src=\"")
    ; __append( require('editor/icons/align_center.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.alignCenterSelection ))
    ; __append("\" />\r\n        <img id=\"align-right\" name=\"align-right\" src=\"")
    ; __append( require('editor/icons/align_right.png') )
    ; __append("\"  style=\"background-color: ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.alignRightSelection ))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6\">\r\n        Min\r\n        <input type=\"text\" name=\"min\" value=\"")
    ; __append(escapeFn( u.roundCeilAbsolute(gridData[selectedRowId].attributes.min)))
    ; __append("\" title=\"Min field allow positive and negative integers (no decimals).\" style=\"width: calc(100% - 30px);\" />\r\n    </div>\r\n    <div class=\"col-md-6\">\r\n        Max\r\n        <input type=\"text\" name=\"max\" value=\"")
    ; __append(escapeFn( u.roundCeilAbsolute(gridData[selectedRowId].attributes.max)))
    ; __append("\" title=\"Max field allow positive and negative integers (no decimals).\" style=\"width: calc(100% - 30px);\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel nopadding-r\">\r\n        Decimals\r\n        <input type=\"text\" name=\"decimalLength\" id=\"decimalLength\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.decimalLength))
    ; __append("\" maxlength=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.maxDecimalCharsLength ))
    ; __append("\"  style=\"width:50px;\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.disabledAll))
    ; __append(" />\r\n    </div>\r\n    <div class=\"col-md-6 form-group-flex nopadding-r\">\r\n        <input type=\"checkbox\" name=\"showLeadingZero\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.disabledAll))
    ; __append("  class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Show Leading Zero</label>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel\">Decimal Separator</div>\r\n    <div class=\"col-md-6\">\r\n        <select name=\"decimalSeparator\" id=\"decimalSeparator\" style=\"width:50px;\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.disabledAll))
    ; __append(">\r\n            <option value=\".\">.</option>\r\n            <option value=\",\">,</option>\r\n        </select>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel nopadding-r\">Thousand Separator</div>\r\n    <div class=\"col-md-6\">\r\n        <select name=\"thousandsSeparator\" id=\"thousandsSeparator\" style=\"width:50px;\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.disabledAll))
    ; __append(">\r\n            <option value=\"\">None</option>\r\n            <option value=\".\">.</option>\r\n            <option value=\",\">,</option>\r\n            <option value=\"'\">'</option>\r\n        </select>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 prop-sublabel\">Currency Symbol</div>\r\n    <div class=\"col-md-6\"><input type=\"text\" id=\"symbol\" name=\"symbol\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.symbol))
    ; __append("\" style=\"width:50px;\" ")
    ; __append(escapeFn( gridData[selectedRowId].attributes.disabledAll))
    ; __append(" /></div>\r\n</div>\r\n")
  }
  return __output;

}